import axios from "axios";

const instance = axios.create({
  // timeout: 30000,
  timeout: 120000,
  
});

export const login = () => {
  return new Promise((resolve, reject) => {
    instance
      .get("http://localhost:3000/login", {})
      .then((result) => {
        console.log("Result in Login ", result);
        if (result.status === 200) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        console.log("Error in get Main ", error.response);
        reject(error);
      });
  });
};

export const loadData = (data: any, dispatch = null) => {
  // console.log("data in Post ::" + url, data);
  return new Promise((resolve, reject) => {
    instance
      .post("http://localhost:3001/report", data)
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data);
        }
      })
      .catch((error) => {
        console.log("error in Post", error);
        reject(error);
      });
  });
};

export const installationData = async () => {
  try {
    const data = await axios("https://api.virtualvisions.io/stores");
    return data;
  } catch (err) {
    console.error(err);
  }
};

export const getSkuData = (
  productSKU: any,
  requestheader: any,
  productName: string
) => {
  //console.log(requestheader)
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `https://api.virtualvisions.io/${productName}/v2/products/${productSKU}/data`,
        {
          headers: requestheader,
        }
      )
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data);
        } else {
          reject(undefined);
        }
      })
      .catch((error) => {
        console.log("error ", error.response);
        reject(error);
      });
  });
};
